import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFetch } from "../../Services/useFetch";

const WordEditor = () => {
  const location = useLocation();
  const { request } = useFetch();
  const scriptLoadedRef = useRef(false);
  const editorRef = useRef(null);
  const queryParams = new URLSearchParams(location.search);

  const fileUrl = queryParams.get("fileID");
  const fileType = queryParams.get("fileType");
  const fldId = queryParams.get("fldId");
  const fldName = queryParams.get("fldName");

  const [editorConfig, setEditorConfig] = useState(false);

  useEffect(() => {
    if (scriptLoadedRef.current) return;
    const script = document.createElement("script");
    script.src = "https://onlyoffice.growthgrids.com/web-apps/apps/api/documents/api.js";
    script.onload = () => {
      console.log("✅ OnlyOffice script loaded");
      scriptLoadedRef.current = true;
      if (fileUrl) getEditorData();
    };
    script.onerror = () => console.error("Failed to load OnlyOffice script.");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!editorConfig || !window.DocsAPI) return;

    if (editorRef.current?.destroyEditor) {
      editorRef.current.destroyEditor();
    }

    // Create a new editor instance
    editorRef.current = new window.DocsAPI.DocEditor("OnlyOfficeEditor", {
      document: editorConfig.config.document,
      editorConfig: editorConfig.config.editorConfig,
      token: editorConfig.token,
    });
  }, [editorConfig]);

  const getEditorData = async () => {
    try {
      const formData = new URLSearchParams();
      fileUrl != null && formData.append("file_id", fileUrl);
      fileType != null && formData.append("filetype", fileType);
      fileType != null && formData.append("folder_id", fldId);
      fldName != null && formData.append("file_name", fldName);
      const response =
        fileType != null
          ? await request("/custom-doc-file", "post", formData, {
              "Content-Type": "application/x-www-form-urlencoded",
            })
          : await request("/only-office-config", "post", formData, {
              "Content-Type": "application/x-www-form-urlencoded",
            });
      if (response?.data?.status == 1) {
        setEditorConfig(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getEditorData();
  }, []);

  return (
    <div className="word-editor">
      <div id="OnlyOfficeEditor" style={{ height: "100vh", width: "100%", border: "1px solid #ccc" }}></div>
    </div>
  );
};

export default WordEditor;
